<div *transloco="let t; prefix: 'activation'" class="w-full text-center">
  @if (error$ | async; as error) {
    <p [innerHtml]="t('token.error', { error })"></p>
  } @else {
    @if (activationTokenDetails$ | async; as activationTokenDetails) {
      <rma-agent-activation
        [profileImageUrl]="activationTokenDetails.profileImageUrl"
        [heading]="t('token.heading', { name: activationTokenDetails.name })"
        [subheading]="t('token.subheading')"
        [cta]="t('token.cta')"
        [termsConditions]="t('token.termsConditions')"
        [pending]="(pending$ | async) ?? false"
        (activateProfile)="activateProfile()"
      />
    } @else {
      <div class="rma-loader">
        <mat-spinner diameter="30" />
      </div>
    }
  }
</div>
